import mutations from './mutations';
import actions from './actions';
import Inquiry, { ThirdPartyData, TourradarInquiry } from "../interfaces/inquiry";
import DataPolicy from "../interfaces/dataPolicy";
import getters from "./getters";
import { FARE_DEFAULT } from "@constants/fares";
import DealResponse from "../interfaces/dealResponse";
import { ADYEN_ID } from "@constants/paymentMethods";
import Voucher from "@store/checkout/interfaces/voucher";

export interface InquiryState {
    inquiry: Inquiry|TourradarInquiry,
    dataPolicy: DataPolicy,
    dealResponse: DealResponse,
    whitelabelConsent: boolean,
    paymentStatus: PaymentStatus,
    voucher: Voucher,
    tourradar: ThirdPartyData
}

export const enum BookingStatus {
    SUCCESS = 'Success',
    APPOINTMENTDATA_CHANGED = 'AppointmentDataChanged',
    PRICE_CHANGED = 'PriceChanged',
    SOLDOUT = 'SoldOut',
    ERROR = 'Error',
    NONE = 'None' // internal value
}

export const enum PaymentStatus {
    SUCCESS = 'success',
    FAILED = 'failure',
    PENDING = 'pending',
}

export const enum RestoreStatus {
    NO_STORED_APPOINTMENT = 'NoStoredAppointment'
}

export const inquiryInitialState: InquiryState = {
    inquiry: {
        sessionId: '',
        contact: {
            salutation: '',
            firstname: '',
            lastname: '',
            street: '',
            zip: '',
            city: '',
            country: '',
            phone: '',
            email: '',
            iso2: ''
        },
        travellers: [],
        paymentMethod: ADYEN_ID, // set default selection
        voucher: '',
        additionalCustomerField: '',
        comment: '',
        consent: {
            journaway: '',
            organizer: '',
            whitelabel: '',
            newsletter: false
        },
        tripId: 0,
        appointmentId: '',
        hsCompanyId: 0,
        rooms: [],
        hotelUpgrades: [],
        services: [],
        carRentals: [],
        travellerCount: {
            adults: 0,
        },
        tracking: {
            stageIdent: '',
            gtm: {
                sessionId: '',
                userId: '',
                clientId: ''
            },
            awin: {
                awaid: '',
                awbid: '',
                awgid: '',
                awpid: '',
                awchecksum: '',
                awclick: '',
                awcr: ''
            },
            travelagency: '',
            travelagencyExternal: '',
            agent: ''
        },
        fare: FARE_DEFAULT
    },
    dataPolicy: {
        __datapolicy_checksum: '',
        __datapolicy_type: '',
        dataPolicyAccepted: false,
        consent: ''
    },
    dealResponse: {
        status: BookingStatus.NONE,
        transactionId: '',
        bookingId: 0,
        message: null,
        bookingStep: null, // used with restore logic (status: AppointmentDataChanged)
        bookingRequest: null // used with restore logic (status: AppointmentDataChanged)
    },
    whitelabelConsent: false,
    paymentStatus: PaymentStatus.SUCCESS,
    voucher: {
        currentVoucher: '',
        isValid: true,
        isValidated: true
    },
    tourradar: {
        thirdPartyInformation: {
            bookedPrice: 0,
            isFlightExcluded: false,
        }
    }
}

export default {
    namespaced: false,
    state: inquiryInitialState,
    mutations,
    actions,
    getters
}
